import React, { useCallback } from 'react';
import SkillItem from './SkillItem';
import Tab from '../../../common/Tab';
import Tabs from '../../../common/Tabs';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedTab } from '../../../../redux/assets/actions';
import Card from '../../../common/Card';

function SkillsList({ skills, onEdit, onDelete }) {
  const dispatch = useDispatch();
  const { selectedTab } = useSelector((state) => state.assets);

  const skillTypeMap = {
    0: 0,
    1: 1,
    2: 2,
  };
  const skillTypeLabels = {
    0: 'Job related skills',
    1: 'Hard skills',
    2: 'Soft skills',
  };

  // Handle tab change
  const handleChangeTab = useCallback(
    (tabIndex) => {
      dispatch(setSelectedTab(tabIndex));
    },
    [dispatch],
  );

  const filteredSkills = skills.filter((skill) => skill.skillType === skillTypeMap[selectedTab]);

  return (
    <div className="skill-list mt-4">
      <Tabs value={selectedTab} onChange={(_, tabValue) => handleChangeTab(tabValue)} TabIndicatorProps={{ style: { background: 'var(--accent-color)' } }}>
        <Tab label="Job Related Skills" />
        <Tab label="Hard Skills" />
        <Tab label="Soft Skills" />
      </Tabs>

      <Card>
        <div className='skill-cards'>
          {filteredSkills.length > 0 ? (
            <div className="row row-cols-2 mt-2">
              {filteredSkills.map((skill) => (
                <div className="col-6" key={skill.id}>
                  <SkillItem skill={skill} onEdit={() => onEdit(skill)} onDelete={() => onDelete(skill.id)} />
                </div>
              ))}
            </div>
          ) : (
            <div className="mt-3">
              <p className="text-muted small text-center">
                No <strong>{skillTypeLabels[selectedTab]}</strong> skills added yet. Add your skills to build your CV.
              </p>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
}

export default SkillsList;
